// extracted by mini-css-extract-plugin
export default {"contractId":"styles_contractId__gpiKw","contractNumber":"styles_contractNumber__wwN3H","copyIcon":"styles_copyIcon__Biq9A"};